import React from "react";
import { Link } from "react-router-dom";
import { useSiteLogo, useSiteContact } from "../api/siteLogo";

function Footer() {
  const logo = useSiteLogo();
  const { phone, email, address } = useSiteContact();
  return (
    <footer className="footer-area light">
      <div className="footer-widget">
        <div className="container">
          <div className="footer-widget-wrap pt-100 pb-50">
            <div className="row g-4">
              {/* About Kademy */}
              <div className="col-lg-5">
                <div className="footer-widget-box about-us">
                  <Link to="/" className="footer-logo">
                    <img src={logo} alt="Kademy Logo" />

                  </Link>
                  <p className="mb-3">
                    Kademy — Your trusted platform to learn, grow and upgrade
                    your skills. 
                  </p>
                </div>
              </div>

              {/* Company Links */}
              <div className="col-6 col-lg-2">
                <h4 className="footer-widget-title">Company</h4>
                <ul className="footer-list">
                  <li>
                    <Link to="/about">About Us</Link>
                  </li>
                  <li>
                    <Link to="/news">News</Link>
                  </li>
                  <li>
                    <Link to="/testimonials">Testimonials</Link>
                  </li>
                  <li>
                    <Link to="/contact">Contact</Link>
                  </li>
                  <li>
                    <Link to="/refund-policy">Refund Policy</Link>
                  </li>
                  {/* NEW LINE ADDED */}
                  <li>
                    <Link to="/terms">Terms & Conditions</Link>
                  </li>
                </ul>
              </div>

              {/* Quick Links */}
              <div className="col-6 col-lg-2">
                <h4 className="footer-widget-title">Quick Links</h4>
                <ul className="footer-list">
                  <li>
                    <Link to="/courses">Courses</Link>
                  </li>
                  <li>
                    <Link to="/current-affairs">Current Affairs</Link>
                  </li>
                  <li>
                    <Link to="/exam-notes">Exam wise notes</Link>
                  </li>
                  {/* <li>
                    <Link to="/become-instructor">Become Instructor</Link>
                  </li> */}
                  <li>
                    <Link to="/help">Help Center</Link>
                  </li>
                  {/* <li>
                    <Link to="/events">Events</Link>
                  </li> */}
                </ul>
              </div>

              {/* Contact */}
              <div className="col-lg-3">
                <h4 className="footer-widget-title">Get In Touch</h4>
                <ul className="footer-contact">
                  <li>
                    <i className="far fa-location-dot"></i> {address}
                  </li>
                  <li>
                    <i className="far fa-phone"></i> {phone}
                  </li>
                  <li>
                    <i className="far fa-envelope"></i> {email}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer bottom */}
      <div className="container text-center py-3">
        <p>
          © 2026 <strong>Kademy</strong>. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
